const SCROLL_STORAGE_KEY = "scroll-positions";

// Save scroll position per route
export const saveScrollPosition = (path) => {
  const positions =
    JSON.parse(sessionStorage.getItem(SCROLL_STORAGE_KEY)) || {};
  positions[path] = window.scrollY;
  sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(positions));
};

// Get saved scroll position for route
export const getScrollPosition = (path) => {
  const positions =
    JSON.parse(sessionStorage.getItem(SCROLL_STORAGE_KEY)) || {};
  return positions[path] || 0;
};

// Clear after restore (optional)
export const clearScrollPosition = (path) => {
  const positions =
    JSON.parse(sessionStorage.getItem(SCROLL_STORAGE_KEY)) || {};
  delete positions[path];
  sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(positions));
};

// Clear all scroll positions
export const clearAllScrollPositions = () => {
  sessionStorage.removeItem(SCROLL_STORAGE_KEY);
};
